import { useEffect, useState } from "react"

import { api } from "@/lib/api"
import type { Profile, RolesSummary } from "@/lib/types"

/**
 * The packs this user works in - from their target roles and their CVs - for
 * every page that offers a choice of track.
 *
 * `null` while loading. `reload` after a role is added or removed.
 */
export function useTracks(): {
  summary: RolesSummary | null
  tracks: Profile[] | null
  reload: () => void
} {
  const [summary, setSummary] = useState<RolesSummary | null>(null)
  const [version, setVersion] = useState(0)

  useEffect(() => {
    let live = true
    api.roles
      .list()
      .then((result) => {
        if (live) setSummary(result)
      })
      .catch(() => {
        // The pages still work with no tracks; they fall back to all packs.
        if (live) setSummary({ roles: [], tracks: [], packs: [], maxRoles: 6 })
      })
    return () => {
      live = false
    }
  }, [version])

  return {
    summary,
    tracks: summary?.tracks ?? null,
    reload: () => setVersion((value) => value + 1),
  }
}
